import(/* webpackMode: "eager" */ "/var/www/front/live/eduvalu-front/app/global-error.tsx")